import ThemeContext from 'lib/next-themes/context';
import type { UseThemeProps } from 'lib/next-themes/types';
import { useContext } from 'react';

const DEFAULT_CONTEXT: UseThemeProps = {
  setTheme: (newTheme: string) => {
    console.error(`No ThemeContext found, not setting theme to ${newTheme}`);
  },
  themes: [],
};

export default function useTheme(): UseThemeProps {
  const context = useContext(ThemeContext) ?? DEFAULT_CONTEXT;

  return context;
}
